import React, { useState } from 'react';
import { usePosts } from '../contexts/PostContext';
import PostCard from '../components/posts/PostCard';

const Home: React.FC = () => {
  const { posts } = usePosts();
  const [activeFilter, setActiveFilter] = useState<'all' | 'following'>('all');

  return (
    <div>
      <div className="flex items-center space-x-6 mb-6 border-b border-gray-200 dark:border-gray-800 pb-4">
        <button
          onClick={() => setActiveFilter('all')}
          className={`text-lg font-medium pb-3 ${
            activeFilter === 'all' 
              ? 'text-gray-900 dark:text-white border-b-2 border-purple-500' 
              : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          For You
        </button>
        <button
          onClick={() => setActiveFilter('following')}
          className={`text-lg font-medium pb-3 ${
            activeFilter === 'following' 
              ? 'text-gray-900 dark:text-white border-b-2 border-purple-500' 
              : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          Following
        </button>
      </div>

      <div className="space-y-6">
        {posts.length === 0 ? (
          <div className="text-center py-10">
            <p className="text-gray-500 dark:text-gray-400 mb-4">No stories available</p>
            <p className="text-sm text-gray-400 dark:text-gray-500">Follow journalists or create your own story</p>
          </div>
        ) : (
          posts.map(post => (
            <PostCard key={post.id} post={post} />
          ))
        )}
      </div>
    </div>
  );
};

export default Home;